export const REPORT_DATES_OPTIONS = [
  { value: 'this_week',  label: 'This Week'  },
  { value: 'last_week',  label: 'Last Week'  },
  { value: 'this_month', label: 'This Month' },
  { value: 'last_month', label: 'Last Month' },
  { value: 'this_year',  label: 'This Year'  },
  { value: 'last_year',  label: 'Prior Year' },
];
